import http from "../utils/http-common";

const getInfo = () => {
  return http.get("/info");
};
const getAll = () => {
  return http.get("/users");
};
const getById = (id: number) => {
  return http.get(`/user/${id}`);
};
const put = (id: number, data: any) => {
  return http.put(`/user/${id}`, data);
};
const remove = (id: number) => {
  return http.delete(`/user/${id}`);
};
const updateStatus = (id: number, status: string) => {
  return http.put(`/user/${id}/status`, { status });
}
export const userService = {
  getAll,
  getById,
  put,
  remove,
  getInfo,
  updateStatus
};

export default userService;
